module.exports = __webpack_public_path__ + "static/media/wizualizacja-51.e074b62a.png";